module.exports = __webpack_public_path__ + "static/media/mlt.654e8cd0.svg";